module.exports = {
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
};
//# sourceMappingURL=breakpoints.js.map